export default __webpack_public_path__ + "static/media/iaeCorner07.7212e823.png";